
<template>
  <div>
    <div v-if="isShowRule" class="rules-modal" @click.self="toggleModal(false)">
      <div class="rules-wrap">
        <div class="title">{{ data.title }}</div>
        <div class="desc" v-html="data.desc"></div>
        <div class="btn-wrap">
          <div class="btn" @click="toggleModal(false)">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class RuleModal extends Vue {
  @Prop({}) data!: number;
  @Prop({}) rules!: number;
  isShowRule = false;

  toggleModal(status: boolean) {
    this.isShowRule = status;
  }
}
</script>

<style lang="scss" scoped>
@import '@style/helps.scss';

.rules-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  background-color: rgba(1, 1, 1, 0.7);
  @include flex(center, center, column);

  .rules-wrap {
    width: 632px;
    height: 937px;
    padding-bottom: 18px;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 1);
    background-image: url(https://res.pandateacher.com/LJ3RJPXI1603873361875.png);
    background-repeat: no-repeat;
    background-position: 0px 90px;
    background-size: 632px 728px;
    border-radius: 10px;
    .title {
      width: 100%;

      height: 88px;
      // color: rgba(255, 255, 255, 1);
      color: rgba(59, 53, 97, 1);
      font-weight: 500;
      // box-shadow: 0px -16px 50px 0px rgba(148, 7, 55, 0.71);

      font-size: 32px;
      line-height: 88px;
      text-align: center;
      // background: linear-gradient(
      //   136deg,
      //   #ffb0b5 0%,
      //   #e61843 44%,
      //   #9104e3 100%
      // );
      background-color: #fff;
    }

    .desc {
      width: 562px;
      height: 728px;
      margin: 0 auto;
      padding: 16px 0 4px 0;
      // margin-left: 50px;
      padding-right: 20px;
      overflow: scroll;
      transform: translateX(16px);
    }
  }
  .btn-wrap {
    width: 100%;
    height: 122px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    box-shadow: 0px 2px 39px 0px rgba(183, 183, 183, 0.5);
    @include flex-center;
  }
  .btn {
    width: 560px;
    height: 80px;
    color: rgba(255, 255, 255, 1);
    font-weight: 500;

    font-size: 34px;
    line-height: 80px;
    text-align: center;
    background-image: linear-gradient(135deg, #4c38cd 0%, #e600e7 100%);
    // box-shadow: 0px 10px 14px -13px #ff00f2;
    border-radius: 8px;
  }
}
</style>